import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort",
  "use": "icon-sort-usage",
  "viewBox": "0 0 8.52 10.67",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.52 10.67\" id=\"icon-sort\"><defs><style>#icon-sort .cls-1{opacity:0.5;}#icon-sort .cls-2{fill:#fff;}</style></defs><g id=\"icon-sort_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-sort_圖層_1-2\" data-name=\"圖層 1\"><g class=\"cls-1\"><polygon class=\"cls-2\" points=\"0 4.26 4.26 0 8.52 4.26 0 4.26\" /><polygon class=\"cls-2\" points=\"8.52 6.41 4.26 10.67 0 6.41 8.52 6.41\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol